import { PrescriptionAndUnhandledOrdersProvider } from 'Context';
import { ExpiredMedicationsMobile } from 'Modules/ExpiredMedicationsLobby/ExpiredMedicationsMobile';

export const ExpiredMedicationsLobby = () => {
  return (
    <PrescriptionAndUnhandledOrdersProvider>
      <ExpiredMedicationsMobile />
    </PrescriptionAndUnhandledOrdersProvider>
  );
};
